export const geolocationOptions = {
  enableHighAccuracy: true,
  // timeout: 1000 * 10 * 1, // 1 min (1000 ms * 60 sec * 1 minute = 60 000ms)
  maximumAge: 1000 * 5 * 1, // 5 sec
};
